import { schema, normalize } from 'normalizr';
import { createActions, asyncAction } from '../helpers/redux';

const accountSchema = new schema.Entity('accounts');
const avatarSchema = new schema.Entity('avatars');
const userSchema = new schema.Entity('users');
const roleSchema = new schema.Entity('roles');

userSchema.define({
  avatar: avatarSchema,
});

const accountUserSchema = new schema.Entity(
  'accountUsers',
  {
    user: userSchema,
    role: roleSchema,
  },
  {
    idAttribute(entity) {
      return entity.user.id;
    },
  },
);

const pendingAccountUserSchema = new schema.Entity('pendingAccountUsers');

const accountUserAllSchema = new schema.Entity(
  'accountUserAll',
  {
    accountUsers: [accountUserSchema],
    pendingAccountUsers: [pendingAccountUserSchema],
  },
  {
    idAttribute() {
      return 0;
    },
  },
);

export const AccountActions = createActions({
  @asyncAction()
  async addUser(accountId, user) {
    return ({ client }) =>
      client
        .post(`/accounts/${accountId}/users`, { body: user })
        .then(response => normalize(response, accountUserAllSchema));
  },

  @asyncAction()
  async changeUserRole(accountId, userId, roleId) {
    return ({ client }) =>
      client
        .patch(`/account/${accountId}/users/${userId}`, {
          body: { role_id: roleId },
        })
        .then(response => response);
  },

  @asyncAction()
  async removeUser(accountId, userId) {
    return ({ client }) =>
      client
        .delete(`/account/${accountId}/users/${userId}`)
        .then(response => response);
  },

  @asyncAction()
  async removePendingUser(accountId, userId) {
    return async ({ client }) => {
      await client.delete(`/account/${accountId}/pendingusers/${userId}`);
      return { accountId, userId };
    };
  },

  @asyncAction()
  async getAccounts(organizationId) {
    return ({ client }) =>
      client
        .get(`/organizations/${organizationId}/accounts`, {
          qs: {
            fields: ['project_count'],
          },
        })
        .then(response => ({
          organizationId,
          result: normalize(response, [accountSchema]),
        }));
  },

  @asyncAction()
  async getAccountUsers(accountId) {
    return ({ client }) =>
      client
        .get(`/account/${accountId}/users`)
        .then(response => normalize(response, accountUserAllSchema));
  },

  @asyncAction()
  async getAccount(accountId) {
    return ({ client }) =>
      client
        .get(`/accounts/${accountId}`)
        .then(response => normalize(response, accountSchema));
  },

  setAccountId(accountId) {
    return {
      accountId,
    };
  },

  @asyncAction()
  async createAccount(account) {
    return ({ client }) =>
      client
        .post('/account', { body: account })
        .then(response => normalize(response, accountSchema));
  },

  @asyncAction()
  async deleteAccount(accountId) {
    return ({ client }) =>
      client.delete(`/accounts/${accountId}`).then(response => response);
  },

  @asyncAction()
  async renameAccount(accountId, accountName) {
    return ({ client }) => {
      return client
        .patch(`/account/${accountId}`, {
          body: { fields: { name: accountName } },
        })
        .then(response => {
          return normalize(response, accountSchema);
        });
    };
  },
});



// WEBPACK FOOTER //
// ./src/actions/account.js